module.exports = __webpack_public_path__ + "img/action_plus.41d3508d.svg";